import { WagonTemplateDamageReport } from '../../../commons/model/templates';
import WagonDamageReportDetails from './WagonDamageReportDetails';
import React from 'react';
import { useAppDispatch } from '../../../commons/store/hooks';
import { openExternalDamageReportDialog } from './form/wagonExternalDucks';

type WagonDamageReportListProps = {
  registration: string;
  damageReports: WagonTemplateDamageReport[];
  canOpenDamageReport: boolean;
};

const WagonDamageReportList = ({ registration, damageReports, canOpenDamageReport }: WagonDamageReportListProps) => {
  const sortedDamageReports = [...damageReports].sort((a, b) => {
    if (b.validatedDate && a.validatedDate) {
      return b.validatedDate.localeCompare(a.validatedDate);
    } else if (a.number && b.number) {
      return b.number.localeCompare(a.number);
    } else {
      return b.updatedDate.localeCompare(a.updatedDate);
    }
  });

  const dispatch = useAppDispatch();
  return (
    <div className="wagon-damage-report-details-list">
      <div className="wagon-damage-report-title">
        <label>Avaries/étiquettes de réforme</label>
        {canOpenDamageReport && (
          <button
            className="btn-icon add"
            style={{ cursor: 'pointer' }}
            onClick={() => dispatch(openExternalDamageReportDialog({ registration }))}
            type="button"
          />
        )}
      </div>
      {sortedDamageReports.length > 0 && (
        <table className="wagon-damage-report-details">
          <tbody>
            <tr>
              <th>N° PVCA</th>
              <th>Étiquettes</th>
              <th>Code d'avarie</th>
              <th>Validation</th>
            </tr>
            {sortedDamageReports.map((damageReport) => (
              <WagonDamageReportDetails
                key={`wagon_damage_report_${damageReport.number}_details`}
                damageReport={damageReport}
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default WagonDamageReportList;
